import angular from 'angular';
import { IVisualizacaoPreviaGeracaoModalData } from './models/visualizacao-previa-geracao.modal.model';

export class VisualizacaoPreviaGeracaoModalService {
    static $inject = ['$uibModal'];

    constructor(public $uibModal: ng.ui.bootstrap.IModalService) {}

    open(entity: IVisualizacaoPreviaGeracaoModalData) {
        return this.$uibModal.open({
            template: require('html-loader!./visualizacao-previa-geracao.modal.html'),
            controller: 'VisualizacaoPreviaGeracaoModalController',
            controllerAs: '$ctrl',
            backdrop: 'static',
            windowClass: 'nsj-modal-lg-no-height',
            resolve: {
                entity: () => angular.copy(entity)
            }
        });
    }
}
